import { render, staticRenderFns } from "./ModalSwitchStores.vue?vue&type=template&id=dced19ce&"
import script from "./ModalSwitchStores.vue?vue&type=script&lang=js&"
export * from "./ModalSwitchStores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports